import { ModalCountProductQuantityReceive } from './ModalCountProductQuantityReceive'

export default ModalCountProductQuantityReceive
